{
    "name": "Apple",
    "binomial_name": "Malus pumila",
    "common_names": [],
    "description": "The apple is a deciduous tree in the Rose family grown for it's sweet fruit. The apple originated in Central Asia and has spread across the world. There are now over 7,500 cultivars bred for a variety of climates and characteristics. Apples are propagated through grafting because seeds do not breed true.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Bare root tree",
    "spread": 500,
    "row_spacing": 0,
    "height": 300,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/apple.jpg",
    "icon": "/crops/icons/apple.avif"
}